import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading } from "../components/Common";
import { sortByAcademicProgression } from "../lib/academicOrder";

export default function Academics() {
  const [classes, setClasses] = useState(null);
  const [subjects, setSubjects] = useState([]);
  useEffect(() => {
    api.classes().then(({ data }) => setClasses(data));
    api.subjects().then(({ data }) => setSubjects(data));
  }, []);
  // Academic-progression sort applied at display time only. Records unchanged.
  const orderedClasses = useMemo(
    () => (classes ? sortByAcademicProgression(classes) : classes),
    [classes]
  );
  if (classes === null) return <Loading />;
  return (
    <div data-testid="academics-page">
      <PageHeader kicker="Academic Management" title="Classes & Subjects" subtitle="Year groups, sections and subject offerings — ordered by academic progression." />
      <Section title="Classes" testId="section-classes">
        <DataTable
          dense
          columns={[
            { key: "name", label: "Class" },
            { key: "year_group", label: "Year Group", render: (r) => r.year_group || "Not assigned" },
            { key: "academic_year", label: "Academic Year", render: (r) => r.academic_year || "Not assigned" },
            { key: "students", label: "Roster", render: (r) => `${(r.student_ids || []).length} students` },
          ]}
          rows={orderedClasses}
        />
      </Section>
      <Section title="Subjects" testId="section-subjects">
        <DataTable
          dense
          columns={[
            { key: "code", label: "Code" },
            { key: "name", label: "Subject" },
            { key: "department", label: "Department" },
          ]}
          rows={subjects}
        />
      </Section>
    </div>
  );
}
